import { comics } from '@/mocks/comics';
import ComicCard from '@/components/feature/ComicCard';

const latestComics = [...comics]
  .sort((a, b) => new Date(b.lastUpdated).getTime() - new Date(a.lastUpdated).getTime())
  .slice(0, 10);

export default function LatestSection() {
  return (
    <section className="py-12 md:py-16">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="mb-8">
          <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-950">
            最近更新
          </h2>
          <p className="text-sm text-foreground-400 mt-1">每日更新最新韩国漫画章节</p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-4 md:gap-5">
          {latestComics.map((comic) => (
            <ComicCard key={comic.id} comic={comic} />
          ))}
        </div>
      </div>
    </section>
  );
}